import React, { useState } from 'react';
import { CheckCircle2, Gift, BookOpen, Utensils, ShoppingCart, Calendar, Coffee, ShieldCheck, Zap } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CTAButton } from './CTAButton';
import { UpsellModal } from './UpsellModal';
export function OfferSection() {
  const discountCheckoutUrl = 'https://pay.hotmart.com/F104765975P?off=9ejqig6u&checkoutMode=10';
  const [isUpsellOpen, setIsUpsellOpen] = useState(false);
  const [is72hExpired, setIs72hExpired] = useState(() => {
    const storedEndTime = localStorage.getItem('cenas_offer_72h_end_time');
    if (storedEndTime) {
      return new Date().getTime() > parseInt(storedEndTime, 10);
    }
    return false;
  });
  const handle72hExpire = () => {
    setIs72hExpired(true);
  };
  return <section id="offer-section" className="py-16 md:py-24 px-4 bg-white relative scroll-mt-10" data-id="element-218">
      <div className="max-w-4xl mx-auto" data-id="element-219">
        <div className="text-center mb-16" data-id="element-220">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-forest mb-4" data-id="element-221">
            Todo Lo Que Incluye Tu Protocolo Completo
          </h2>
          <p className="text-lg text-dark/60" data-id="element-222">
            El stack de transformación nocturna más completo
          </p>
        </div>

        {/* Main Product */}
        <div className="bg-cream p-6 md:p-8 rounded-2xl border-2 border-forest/20 shadow-sm mb-8 relative overflow-hidden" data-id="element-223">
          <div className="absolute top-0 right-0 bg-forest text-white px-4 py-1 rounded-bl-xl font-bold text-sm" data-id="element-224">
            PRODUCTO PRINCIPAL
          </div>
          <div className="flex flex-col md:flex-row gap-6 items-center md:items-start" data-id="element-225">
            <div className="w-24 h-24 bg-white rounded-xl shadow-sm flex items-center justify-center shrink-0 border border-forest/10" data-id="element-226">
              <BookOpen size={40} className="text-forest" data-id="element-227" />
            </div>
            <div data-id="element-228">
              <h3 className="font-serif text-2xl font-bold text-forest mb-2" data-id="element-229">
                Cenas Anti-Inflamatorias en 15 Minutos — Guía Maestra (PDF)
              </h3>

              <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-dark/80" data-id="element-230">
                <li className="flex items-start gap-2" data-id="element-231">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-232" />{' '}
                  El Método de Digestión en Reposo
                </li>
                <li className="flex items-start gap-2" data-id="element-233">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-234" />{' '}
                  Los 7 Pilares de la Cena
                </li>
                <li className="flex items-start gap-2" data-id="element-235">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-236" />{' '}
                  El sistema del Plato 50-25-25
                </li>
                <li className="flex items-start gap-2" data-id="element-237">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-238" />{' '}
                  Los 8 culpables ocultos
                </li>
                <li className="flex items-start gap-2" data-id="element-239">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-240" />{' '}
                  Guía de especias carminativas
                </li>
                <li className="flex items-start gap-2" data-id="element-241">
                  <CheckCircle2 size={16} className="text-success shrink-0 mt-0.5" data-id="element-242" />{' '}
                  Protocolo de Timing Digestivo
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bonuses Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-243">
          {/* Bonus 1 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-244">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-245">
              B1
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-246">
              <Utensils className="text-gold" size={24} data-id="element-247" />
              <h4 className="font-bold text-lg text-forest" data-id="element-248">
                Recetario Maestro 21 Cenas
              </h4>
            </div>
            <p className="text-sm text-dark/70 mb-3" data-id="element-249">
              21 recetas organizadas en 4 categorías (Mar, Aves, Vegetales,
              Huevo). Máximo 15 minutos.
            </p>
            <ul className="text-sm text-dark/80 space-y-1" data-id="element-250">
              <li className="flex items-center gap-2" data-id="element-251">
                <CheckCircle2 size={14} className="text-success" data-id="element-252" /> Lista de
                ingredientes exacta
              </li>
              <li className="flex items-center gap-2" data-id="element-253">
                <CheckCircle2 size={14} className="text-success" data-id="element-254" /> Pasos con
                tiempos reales
              </li>
              <li className="flex items-center gap-2" data-id="element-255">
                <CheckCircle2 size={14} className="text-success" data-id="element-256" /> Variante
                rápida de emergencia
              </li>
            </ul>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-257">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-258">
              B2
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-259">
              <ShoppingCart className="text-gold" size={24} data-id="element-260" />
              <h4 className="font-bold text-lg text-forest" data-id="element-261">
                Checklist de Compras
              </h4>
            </div>
            <p className="text-sm text-dark/70 mb-3" data-id="element-262">
              Tu guía de compras definitiva para una cocina anti-inflamatoria.
            </p>
            <ul className="text-sm text-dark/80 space-y-1" data-id="element-263">
              <li className="flex items-center gap-2" data-id="element-264">
                <CheckCircle2 size={14} className="text-success" data-id="element-265" /> Qué eliminar
                hoy mismo
              </li>
              <li className="flex items-center gap-2" data-id="element-266">
                <CheckCircle2 size={14} className="text-success" data-id="element-267" /> 25
                ingredientes básicos
              </li>
              <li className="flex items-center gap-2" data-id="element-268">
                <CheckCircle2 size={14} className="text-success" data-id="element-269" /> Guía de
                etiquetado en el súper o mercado
              </li>
            </ul>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-270">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-271">
              B3
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-272">
              <Calendar className="text-gold" size={24} data-id="element-273" />
              <h4 className="font-bold text-lg text-forest" data-id="element-274">
                Planificador Semanal
              </h4>
            </div>
            <ul className="text-sm text-dark/80 space-y-1 mt-2" data-id="element-275">
              <li className="flex items-center gap-2" data-id="element-276">
                <CheckCircle2 size={14} className="text-success" data-id="element-277" /> Plantilla de
                7 días imprimible
              </li>
              <li className="flex items-center gap-2" data-id="element-278">
                <CheckCircle2 size={14} className="text-success" data-id="element-279" /> Seguimiento
                de síntomas
              </li>
              <li className="flex items-center gap-2" data-id="element-280">
                <CheckCircle2 size={14} className="text-success" data-id="element-281" /> Escala de
                inflamación matutina
              </li>
            </ul>
          </div>

          {/* Bonus 4 & 5 Combined */}
          <div className="bg-white p-6 rounded-2xl border border-gold/30 shadow-sm relative" data-id="element-282">
            <div className="absolute -top-3 -left-3 bg-gold text-forest-dark w-10 h-10 rounded-full flex items-center justify-center font-bold shadow-md" data-id="element-283">
              B4+5
            </div>
            <div className="flex items-center gap-3 mb-4" data-id="element-284">
              <Coffee className="text-gold" size={24} data-id="element-285" />
              <h4 className="font-bold text-lg text-forest" data-id="element-286">
                Infusiones o tés & Ritual
              </h4>
            </div>
            <ul className="text-sm text-dark/80 space-y-1 mt-2" data-id="element-287">
              <li className="flex items-center gap-2" data-id="element-288">
                <CheckCircle2 size={14} className="text-success" data-id="element-289" /> 5 infusiones
                post-cena eficaces
              </li>
              <li className="flex items-center gap-2" data-id="element-290">
                <CheckCircle2 size={14} className="text-success" data-id="element-291" /> Ritual de
                cierre de 30 min
              </li>
              <li className="flex items-center gap-2" data-id="element-292">
                <CheckCircle2 size={14} className="text-success" data-id="element-293" /> Respiración
                4-7-8 anti-cortisol
              </li>
            </ul>
          </div>
        </div>

        {/* SUPER LLAMATIVA OFFER STACK */}
        <div className="bg-forest rounded-3xl p-1 shadow-2xl relative overflow-hidden mt-20" data-id="element-294">
          <div className="absolute inset-0 bg-gradient-to-r from-gold via-white to-gold opacity-30 animate-[spin_4s_linear_infinite] scale-150" data-id="element-295"></div>

          <div className="bg-cream rounded-[22px] p-6 md:p-10 relative z-10" data-id="element-296">
            <div className="text-center mb-8" data-id="element-297">
              <h3 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-2" data-id="element-298">
                Resumen de tu Inversión
              </h3>
              <p className="text-dark/60" data-id="element-299">Todo lo que te llevas hoy</p>
            </div>

            <div className="space-y-3 mb-8 max-w-lg mx-auto" data-id="element-300">
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-301">
                <span className="text-dark/80 font-medium" data-id="element-302">
                  Guía Maestra Anti-Inflamatoria
                </span>
                <span className="text-dark/50 line-through" data-id="element-303">$1,079 MXN</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-304">
                <span className="text-dark/80 font-medium" data-id="element-305">
                  Recetario Maestro 21 Cenas
                </span>
                <span className="text-dark/50 line-through" data-id="element-306">$619 MXN</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-307">
                <span className="text-dark/80 font-medium" data-id="element-308">
                  Checklist Compras
                </span>
                <span className="text-dark/50 line-through" data-id="element-309">$389 MXN</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-310">
                <span className="text-dark/80 font-medium" data-id="element-311">
                  Planificador Semanal
                </span>
                <span className="text-dark/50 line-through" data-id="element-312">$275 MXN</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-313">
                <span className="text-dark/80 font-medium" data-id="element-314">
                  Guía de Infusiones o tés
                </span>
                <span className="text-dark/50 line-through" data-id="element-315">$389 MXN</span>
              </div>
              <div className="flex justify-between items-center border-b border-forest/10 pb-2" data-id="element-316">
                <span className="text-dark/80 font-medium" data-id="element-317">
                  Ritual de Cierre 30 Minutos
                </span>
                <span className="text-dark/50 line-through" data-id="element-318">$389 MXN</span>
              </div>
              <div className="flex justify-between items-center pt-2" data-id="element-319">
                <span className="text-forest font-bold text-lg" data-id="element-320">
                  VALOR TOTAL REAL:
                </span>
                <span className="text-urgency font-bold text-xl line-through" data-id="element-321">
                  $3,142 MXN
                </span>
              </div>
            </div>

            {/* PRICING BOX — SINGLE PHASE */}
            <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-gold text-center relative" data-id="element-322">
              <p className="text-dark/70 font-medium mb-2 mt-2" data-id="element-323">
                Precio Especial Por Tiempo Limitado:
              </p>

              <div className="flex flex-col items-center gap-1 mb-6" data-id="element-324">
                <div className="flex items-center gap-3" data-id="element-325">
                  <span className="text-lg text-dark/30 line-through font-medium" data-id="element-326">
                    Valor real: $3,142 MXN
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-327">
                  <span className="text-2xl text-dark/40 line-through font-bold" data-id="element-328">
                    Precio regular: $665 MXN
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-2" data-id="element-329">
                  <span className="text-sm text-success font-semibold uppercase tracking-wide" data-id="element-330">
                    Disponible hoy:
                  </span>
                </div>
                <span className="text-6xl md:text-7xl font-serif font-bold text-success drop-shadow-sm" data-id="element-331">
                  $367{' '}
                  <span className="text-3xl md:text-4xl align-baseline" data-id="element-332">
                    MXN
                  </span>
                </span>
              </div>

              <div className="bg-forest/5 rounded-xl p-4 mb-8 text-sm text-dark/80 flex items-center justify-center gap-2" data-id="element-333">
                <Gift size={18} className="text-gold" data-id="element-334" />
                <span data-id="element-335">
                  Incluye derecho a{' '}
                  <strong data-id="element-336">recibir todas las actualizaciones futuras</strong>{' '}
                  gratis.
                </span>
              </div>

              {!is72hExpired && <CountdownTimer theme="light" className="mb-8" storageKey="cenas_offer_72h_end_time" durationMs={72 * 60 * 60 * 1000} onExpire={handle72hExpire} data-id="element-337" />}

              <CTAButton text="SÍ, QUIERO DESINFLAMARME HOY" onClick={() => setIsUpsellOpen(true)} variant="urgency" className="text-xl md:text-2xl py-5" showTrust={false} data-id="element-338" />

              <p className="text-xs text-dark/50 mt-4" data-id="element-339">
                Acceso inmediato • Descarga instantánea • Garantía 30 días
              </p>

              {/* Payment Methods */}
              <div className="mt-6 pt-6 border-t border-forest/10 flex flex-col items-center gap-4" data-id="element-340">
                <p className="text-xs text-dark/60 font-medium" data-id="element-341">
                  Pagos disponibles con todas las tarjetas
                </p>
              </div>

              {/* Trust badges */}
              <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-342">
                <div className="flex items-center gap-2 text-sm text-dark/80 font-medium" data-id="element-343">
                  <div className="bg-success/10 p-2 rounded-full" data-id="element-344">
                    <ShieldCheck size={18} className="text-success" data-id="element-345" />
                  </div>
                  <span data-id="element-346">Garantía 30 días</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-dark/80 font-medium" data-id="element-347">
                  <div className="bg-forest/10 p-2 rounded-full" data-id="element-348">
                    <Zap size={18} className="text-forest" data-id="element-349" />
                  </div>
                  <span data-id="element-350">Acceso inmediato post-pago</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <UpsellModal isOpen={isUpsellOpen} onClose={() => setIsUpsellOpen(false)} baseCheckoutUrl={discountCheckoutUrl} data-id="element-351" />
    </section>;
}